export default function(esinp, exp) {
  return (Math.pow((1 - esinp) / (1 + esinp), exp));
}


//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/srat.js
// module id = qRBh
// module chunks = 0